import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid,ResponsiveContainer } from 'recharts';
import AxiosURL from '../../ApiService/AxiosURL';
import React,{useState, useEffect} from "react";
import DonutChart from 'react-donut-chart';
import Sidebar from '../layout/Sidebar';
import Header from '../layout/Header';
import Footer from '../layout/Footer';
import Breadcrumb from './Breadcrumb';  
import emitter from "./emitter";  
import { Loader } from 'rsuite';
import PieChart from './PieChart';
import { Pie } from 'react-chartjs-2';

import Highcharts from 'highcharts'
import Highcharts3D from 'highcharts/highcharts-3d'
import HighchartsReact from 'highcharts-react-official'

export default function Fertilizer() {

  // EndPoint 
  const fertilizerAPI = "farmers/fertilizers";
  const pesticideApi = "farmers/pesticides";
  const effect_on_farmer_income = "farmers/effect_on_farmer_income";
  const fert_input_endp = "farmers/InputCostforFertilizer";
  // define state
  const [fertilizers, setFertilizers] = useState([]);
  const [pesticide, setPesticide] = useState([]);
  const [farmerIncome, setFarmerIncome] = useState([]);
  
  
  const [pieFertilizerData, setPieFertilizerData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isFertilizersLoading, setIsFertilizersLoading] = useState(false);
  const [isPesticideLoading, setIsPesticideLoading] = useState(false);
  const [year, setYear] = useState([]);
  const colors = ['#43A19E', '#7B43A1', '#F2317A',];
  // call the fction and pass the endpoint through useeffect
  useEffect(()=>{
    fetchFertilizerDatas(fertilizerAPI);
    fetchPesticideDatas(pesticideApi)
    fetchefarmerIncomeDatas(effect_on_farmer_income)
    fetchFertilizerDataforPie(fert_input_endp);
    const lister = emitter.addListener("sendFilterData",districtDataFilter)
    return ()=>lister.remove();
  }, [])
  // definition of function
  const fetchFertilizerDatas = async(url) => {
    setIsFertilizersLoading(true);
    try{
      const response = await AxiosURL.get(url);
      setFertilizers(response.data.data);
      setIsFertilizersLoading(false)
    }catch(error){
      console.log(error);
    }
  } 
  // definition of function
  const fetchPesticideDatas = async(url) => {
    setIsPesticideLoading(true)
    try{
      const response = await AxiosURL.get(url);
      setPesticide(response.data.data);
      setIsPesticideLoading(false)
    }catch(error){
      console.log(error);
    }
  } 
  
   // definition of function
   const fetchefarmerIncomeDatas = async(url) => {
    try{
      const response = await AxiosURL.get(url);
      setFarmerIncome(response.data.data);
    }catch(error){
      console.log(error);
    }
  } 
  
  const fetchFertilizerDataforPie = async(url) => {
    try{
      setIsLoading(true);
      const response = await AxiosURL.get(url);
      setPieFertilizerData(response.data.data);
      setIsLoading(false);
    }catch(error){
      console.log(error);
    }
  }
  // Ganesh was written the code
  const districtDataFilter = async (distData)=>{
    if(distData.district == 'select')
    {
      fetchFertilizerDatas(fertilizerAPI);
      fetchPesticideDatas(pesticideApi);
    }else{
      // setIsLoading(true);
      const dertilizersData = await AxiosURL.get(fertilizerAPI,{ params:distData})
      setFertilizers(dertilizersData.data.data);
      // fertilizerDataforPie(distData);
      // setIsLoading(false);
    }
  }
  // const fertilizerDataforPie = async (distData)=>{
  //   const pieChartResponse = await AxiosURL.get(fert_input_endp,{ params:distData})
  //   setPieFertilizerData(pieChartResponse.data.data);
  // } 

  // const filteredByYear =async(data,yearVal)=>{
  //   if(data.target.value == 'select')
  //   {
  //     fetchFertilizerDataforPie(fert_input_endp);
  //   }else{
  //     setIsLoading(true);
  //     const response = await AxiosURL.get(fert_input_endp, { params:{year:yearVal}});
  //     setPieFertilizerData(response.data.data);    
  //     setIsLoading(false);
  //   } 
  // }

  const data = {
    labels: [
      'MFA',
      'NON-MFA'
    ],
    datasets: [{
      data: [5667, 223829],
      backgroundColor: [
      '#FF6384',
      '#36A2EB'
      ],
      hoverBackgroundColor: [
      '#FF6384',
      '#36A2EB'
      ]
    }]
  };
  
  const option = {
    tooltips: {
      callbacks: {
        label: function(tooltipItem, data) {
          var dataset = data.datasets[tooltipItem.datasetIndex];
          var meta = dataset._meta[Object.keys(dataset._meta)[0]];
          var total = meta.total;
          var currentValue = dataset.data[tooltipItem.index];
          var percentage = parseFloat((currentValue/total*100).toFixed(1));
          return currentValue + ' (' + percentage + '%)';
        },
        title: function(tooltipItem, data) {
          return data.labels[tooltipItem[0].index];
        }
      }
    }
  }
  const options = {
    colors: ['#C8463F', '#3A6CC4', '#FAC200'],
    chart: {
      type: 'pie',
      options3d: {
        enabled: true,
        alpha: 45,
        beta: 0
      }
    },
    title: {
      text: ''
    },
    tooltip: {
      pointFormat: '<b>{point.percentage:.1f}%</b>'
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        depth: 35,
        dataLabels: {
          enabled: true,
          format: '{point.name}'
        }
      }
    },
    series: [{
      data: [{
        name: 'Input cost ('+ Math.round((( pieFertilizerData.input_cost)/( pieFertilizerData.input_cost + pieFertilizerData.fertilizer_price + pieFertilizerData.pesticide_price) * 100)) + ' %)',
        y: pieFertilizerData.input_cost,
      }, {
        name: 'Fertilizer cost ('+ Math.round((( pieFertilizerData.fertilizer_price)/( pieFertilizerData.input_cost + pieFertilizerData.fertilizer_price + pieFertilizerData.pesticide_price) * 100)) + ' %)',
        y: pieFertilizerData.fertilizer_price,
      }, {
        name: 'Pesticide cost ('+ Math.round((( pieFertilizerData.pesticide_price)/( pieFertilizerData.input_cost + pieFertilizerData.fertilizer_price + pieFertilizerData.pesticide_price) * 100)) + ' %)',
        y: pieFertilizerData.pesticide_price
      }]
    }],
    credits: false,
    exporting: {
      enabled: false
    }
  }

Highcharts3D(Highcharts)
  return (
    <div className='wrapper'>
    <Sidebar />
    <div className='main'>
      <Header />
      <main className='content'>
        <div className='container-fluid p-0'>

<section>
  <div className='row'>
    <div className='col col-md-8'>

                  <div className='card graphCard'>
                    <div className='card-body'>
                      <b>Input coat farmers (INR Per Ha)</b>
                    <ResponsiveContainer width="100%" height={400} >
                    {isLoading ? <Loader size="md"/> : 
                    <BarChart data={pieFertilizerData}
                        margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                    
                        <XAxis dataKey="year" />
                        <YAxis />
                        <CartesianGrid strokeDasharray="3 3" />
                        <Tooltip />
                        <Legend/>
                        <Bar type="monotone" dataKey="input_cost" stroke="#229af5" fillOpacity={1} fill="#229af5"  unit=" Rs./h"/>
                        <Bar type="monotone" dataKey="fertilizer_price" stroke="#00BB00" fillOpacity={1} fill="#00BB00" unit=" Rs./h" />
                        <Bar type="monotone" dataKey="pesticide_price" stroke="#FF9900" fillOpacity={1} fill="#FF9900" unit=" kg/h" />
                        <Bar type="monotone" dataKey="other_cost" stroke="#FFF000" fillOpacity={1} fill="#FFF000" unit=" kg/h" />
                      </BarChart>
                    }
                    </ResponsiveContainer>
                    </div>
                  </div>
                </div>
                <div className='col-md-4'>
                <div className='card graphCard'>
                  <div className='card-body'>
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">Year</th>
                        <th scope="col" style={{ backgroundColor: '#00BB00', color:"#000000"}}>Input cost</th>
                        <th scope="col" style={{ backgroundColor: '#229af5', color:"#000000"}}>Fertilizer Price</th>
                        <th scope="col" style={{ backgroundColor: '#FF9900', color:"#000000"}}>Pesticide Price</th>
                        <th scope="col" style={{ backgroundColor: '#FFF000', color:"#000000"}}>Other cost</th>
                      </tr>
                    </thead>
                    <tbody>
                    {pieFertilizerData.map(( allData, index ) => {
                    return (<tr key={index}>
                        <td >{allData.year}</td>
                        <td style={{ backgroundColor: '#00BB00', color:"#000000"}}>{allData.input_cost}</td>
                        <td style={{ backgroundColor: '#229af5', color:"#000000"}}>{allData.fertilizer_price}</td>
                        <td style={{ backgroundColor: '#FF9900', color:"#000000"}}>{allData.pesticide_price}</td>
                        <td style={{ backgroundColor: '#FFF000', color:"#000000"}}>{(allData.fertilizer_price -allData.pesticide_price)}</td>
                      </tr>)
                    })}
                    </tbody>
                  </table>
                  </div>
                </div>
                </div>
        </div>
        <div className='row'>
        <Breadcrumb /><br/>
        <div className='col col-md-8'>
          <div className='card graphCard'>
            <div className='card-body'>
              <b>Farmer use of fertilizer (kg per ha)</b>
              <ResponsiveContainer width="95%" height={400}>
              {isFertilizersLoading ? <Loader size="md"/> : 
                <BarChart
                width={400}
                height={400}
                data={fertilizers}
                margin={{
                  top: 15,
                  right: 30,
                  left: 20,
                  bottom: 5
                }}
                barSize={45}
              >
                <XAxis dataKey="year" />
                <YAxis />
                <Tooltip cursor={false} />
                <Legend />
                <CartesianGrid strokeDasharray="3 3" />
                <Bar dataKey="Fertilizer" fill="#FF9900"  unit=" kg/h"/>
              </BarChart> 
          }
          </ResponsiveContainer>
                {/* End  Bar Chart*/}
            </div>
          </div>
        </div>
        <div className='col col-md-4'>
        <div className='card graphCard '>
          <div className='card-body'>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">Year</th>
                  <th scope="col" style={{ backgroundColor: '#FF9900', color:"#000000"}}>Fertilizer</th>
                </tr>
              </thead>
              <tbody>
              {fertilizers.map(( listValue, index ) => {
              return (<tr key={index}>
                  <td >{listValue.year}</td>
                  <td style={{ backgroundColor: '#FF9900', color:"#000000"}}>{listValue.Fertilizer}</td>
                </tr>)
              })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
</div>
<div className='row'>
  <div className='col col-md-8'>
    <div className='card graphCard'>
      <div className='card-body'>
        <b>Farmer use of pesticide (kg per ha)</b>
        <ResponsiveContainer width="95%" height={400}>  
        {isPesticideLoading ? <Loader size="md"/> :       
            <BarChart
            data={pesticide}
            margin={{
              top: 15,
              right: 30,
              left: 20,
              bottom: 5
            }}
            barSize={45}
          >
            <XAxis dataKey="year"  />
            <YAxis />
            <Tooltip cursor={false}/>
            <Legend />
            <CartesianGrid strokeDasharray="3 3" />
            <Bar dataKey="Pesticide" fill="#229af5"  unit=" lt./h"/>
          </BarChart> 
    } 
    </ResponsiveContainer>
      </div>
    </div>
  </div>
  <div className='col col-md-4'>
        <div className='card graphCard '>
          <div className='card-body'>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">Year</th>
                  <th scope="col" style={{ backgroundColor: '#229af5', color:"#000000"}}>Pesticide</th>
                </tr>
              </thead>
              <tbody>
              {pesticide.map(( listValue, index ) => {
              return (<tr key={index}>
                  <td >{listValue.year}</td>
                  <td style={{ backgroundColor: '#229af5', color:"#000000"}}>{listValue.Pesticide}</td>
                </tr>)
              })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
  </div>
  <div className='row'>
  <div className='col col-md-8'>
    <div className='card graphCard'>
      <div className='card-body'>
      {/*start  Bar graph  for input effect*/}
      <b>Input effect on farmer income </b>
        <ResponsiveContainer width="95%" height={400}>
        <BarChart
      data={farmerIncome}
      margin={{
        top: 15,
        right: 30,
        left: 20,
        bottom: 5
      }}
      barSize={45}
    >
      <XAxis dataKey="year"/>
      <YAxis />
      <Tooltip cursor={false} />
      <Legend />
      <CartesianGrid strokeDasharray="3 3" />
      <Bar dataKey="input_cost" fill="#229af5 " stackId="a" unit=" Rs./h/y"/>
      <Bar dataKey="net_income" fill="#FF9900" stackId="a" unit=" Rs./h/y"/>
    </BarChart> 
    </ResponsiveContainer>
       {/* End  Bar Chart for input effect*/}
       
      </div>
    </div>
  </div>
  <div className='col col-md-4'>
        <div className='card graphCard '>
          <div className='card-body'>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">Year</th>
                  <th scope="col" style={{ backgroundColor: '#229af5', color:"#000000"}}>Input cost</th>
                  <th scope="col" style={{ backgroundColor: '#FF9900', color:"#000000"}}>Net income</th>
                </tr>
              </thead>
              <tbody>
              {farmerIncome.map(( listValue, index ) => {
              return (<tr key={index}>
                  <td >{listValue.year}</td>
                  <td style={{ backgroundColor: '#229af5', color:"#000000"}}>{listValue.input_cost}</td>
                  <td style={{ backgroundColor: '#FF9900', color:"#000000"}}>{listValue.net_income}</td>
                </tr>)
              })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
</div>
<div className='footer'>
    <Footer />
   </div>
   </section>
   </div>
  </main>
 </div>
</div>
  )
}
